import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  accordions: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
  },
  box: {
    maxHeight: '30px',
    minHeight: '30px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  actionRow: {
    display: 'flex',
  },
  confirm: {
    margin: '0 0 0 12px',
  },
  button: {
    padding: '0.3rem 1rem',
    fontSize: '12px',
    marginRight: '10px',
    whiteSpace: 'nowrap',
  },
  buttonMargin: {
    margin: '0 12px',
  },
}));

export default useStyles;